<template>
  <div class="addressList">
    <div class="navBar-wrap">
      <div class="select-navBar">
        <div class="arrow" @click="goBack"><van-icon name="arrow-left" /></div>
        <p class="title">{{ user.companyName }}</p>
      </div>
    </div>
    <div class="addressList-nav">
      <div class="searchBox" @click="toSearch">
        <van-field
          v-model="searchName"
          :placeholder="$t('请输入搜索关键字')"
          :left-icon="require('@/assets/images/search.png')"
          class="search-name"
          disabled
        />
      </div>
      <div class="menu-box">
        <div @click="toIndex">{{ $t('组织成员') }}</div>
        <ul class="child-menu">
          <li
            v-for="(item, idx) in navList"
            :key="item.departmentId"
            :style="{
              color: idx + 1 == navList.length ? '#333333' : '#009BFF',
            }"
            @click="toMenu(item, idx)"
          >
            <img src="@/assets/images/pull.png" alt="" />
            <p>{{ item.departmentName }}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="addressList-all">
      <van-checkbox-group v-model="selAll" ref="selectedAll">
        <van-checkbox @click="toggleAll" name="all">{{
          $t('全选')
        }}</van-checkbox>
      </van-checkbox-group>
    </div>
    <div
      class="addressList-card"
      :style="{ maxHeight: addressHeight, minHeight: addressHeight }"
    >
      <van-checkbox-group
        v-model="indexResult"
        ref="departments"
        v-show="showAddressList"
      >
        <van-cell-group>
          <van-cell
            v-for="item in currentInfo"
            clickable
            :key="item.departmentId"
          >
            <template #title>
              <van-checkbox
                :name="item.departmentId"
                @click="changeIndexDepartmentId(item)"
                :disabled="
                  item.children && item.children.length == 0 && !item.staffs
                "
              >
                {{ item.departmentName }}
                <span :style="{ color: '#999999' }">
                  ({{ item.selectNum > 0 ? item.selectNum + '/' : null
                  }}{{ item.totalStaffCount }}{{ $t('人)') }}</span
                >
              </van-checkbox>
            </template>
            <template #right-icon>
              <div
                @click="toChild(item)"
                class="contact-card"
                v-show="item.totalStaffCount != 0"
              >
                <div></div>
                <img
                  :src="
                    item.selectNum > 0
                      ? require('@/assets/images/inferior_actived.png')
                      : require('@/assets/images/inferior.png')
                  "
                  alt=""
                />
                <span
                  :style="{
                    opacity: item.selectNum > 0 ? 0.5 : 1,
                    color: '#009BFF',
                  }"
                  >{{ $t('下级') }}</span
                >
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div v-show="!showAddressList">
        <van-checkbox-group v-model="result" ref="childDepartments">
          <van-cell-group>
            <van-cell
              v-for="item in currentInfo.children"
              clickable
              :key="item.departmentId"
            >
              <template #title>
                <van-checkbox
                  :name="item.departmentId"
                  @click="changeDepartmentId(item)"
                  :disabled="
                    item.children && item.children.length == 0 && !item.staffs
                  "
                >
                  {{ item.departmentName }}
                  <span :style="{ color: '#999999' }">
                    ({{ item.selectNum > 0 ? item.selectNum + '/' : null
                    }}{{ item.totalStaffCount }}{{ $t('人)') }}</span
                  >
                </van-checkbox>
              </template>
              <template #right-icon>
                <div
                  @click="toChild(item)"
                  class="contact-card"
                  v-show="item.totalStaffCount != 0"
                >
                  <div></div>
                  <img
                    :src="
                      item.selectNum > 0
                        ? require('@/assets/images/inferior_actived.png')
                        : require('@/assets/images/inferior.png')
                    "
                    alt=""
                  />
                  <span
                    :style="{
                      opacity: item.selectNum > 0 ? 0.5 : 1,
                      color: '#009BFF',
                    }"
                    >{{ $t('下级') }}</span
                  >
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <van-checkbox-group
          v-model="staffResult"
          ref="staffs"
          :style="{ marginTop: '12px' }"
        >
          <van-cell-group>
            <van-cell
              v-for="item in currentInfo.staffs"
              clickable
              :key="item.staffId + ':' + item.departmentId"
            >
              <template #title>
                <van-checkbox
                  :name="item.staffId"
                  @click="changeStaff(item.staffId, item.exceed)"
                >
                  <div class="staffs-card">
                    <img
                      :src="
                        item.faceUrl ||
                        require('@/assets/images/default_avatar.png')
                      "
                      alt=""
                    />
                    <div>
                      <div class="staffs-card-title">
                        <div class="staffs-card-name">{{ item.staffName }}</div>
                        <div v-if="item.leader" class="staffs-card-tag">
                          {{ $t('主管') }}
                        </div>
                      </div>
                      <div class="staffs-card-job">{{ item.jobPost }}</div>
                    </div>
                  </div>
                </van-checkbox>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
    <div class="agreeBox">
      <div class="select-info">
        {{ $t('已选：') }}{{ selectNum }}{{ $t('人，其中有')
        }}{{ selectdepartmentNum }}{{ $t('部门')
        }}<img src="@/assets/images/pullup.png" alt="" @click="toDisplay" />
      </div>
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="agree-btn"
        @click="onConfirm"
        >{{ $t('确定') }}</van-button
      >
    </div>
    <van-popup
      v-model="showSelected"
      position="bottom"
      :style="{ height: '100%', background: '#F6F6F6' }"
    >
      <div class="navBar-wrap">
        <div class="selected-navBar">
          <div class="left-icon" @click="showSelected = false">
            <van-icon name="arrow-left" />
          </div>
          <p class="title">{{ $t('已选择数量：') }}{{ selectNum }}</p>
        </div>
      </div>
      <div class="display-wrap">
        <ul>
          <li v-for="item in displayList.department" :key="item.departmentId">
            <p>
              <span :style="{ color: '#009BFF' }">{{
                item.departmentName
              }}</span>

              <span :style="{ color: '#999999' }">
                ({{ item.totalStaffCount }}{{ $t('人)') }}</span
              >
            </p>
            <img
              src="@/assets/images/close-circle.png"
              alt=""
              @click="delDepartment(item.departmentId)"
            />
          </li>
        </ul>
        <ul>
          <li
            v-for="(item, idx) in displayList.staff"
            :key="item.id + parseInt(Math.random() * 1000)"
          >
            <p>{{ item.name }}</p>
            <img
              src="@/assets/images/close-circle.png"
              alt=""
              @click="delstaff(item.id, idx)"
            />
          </li>
        </ul>
      </div>
    </van-popup>
    <van-popup v-model="showSearch" class="search-model">
      <div class="search-navBar">
        <div class="left-icon" @click="leaveSearch">
          <van-icon name="arrow-left" />
        </div>
        <div class="searchBox">
          <van-field
            v-model="searchName"
            :placeholder="$t('请输入搜索关键字')"
            :left-icon="require('@/assets/images/search.png')"
            class="search-name"
            clearable
            @input="selectStaff"
          />
        </div>
      </div>
      <van-checkbox-group v-model="searchResult" class="search-list">
        <van-cell-group>
          <van-cell v-for="item in searchList" clickable :key="item.id">
            <template #title>
              <van-checkbox
                :name="item.id"
                @click="changeStaffBySearch(item.id)"
              >
                <div class="staffs-card">
                  <img
                    :src="
                      item.faceUrl ||
                      require('@/assets/images/default_avatar.png')
                    "
                    alt=""
                  />
                  <div>
                    <div class="staffs-card-name">{{ item.name }}</div>
                    <div class="staffs-card-job">{{ item.jobPost }}</div>
                  </div>
                </div>
              </van-checkbox>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div class="agreeBox" :style="{ position: 'absolute' }">
        <div class="select-info">
          {{ $t('已选：') }}{{ selectNum }}{{ $t('人，其中有')
          }}{{ selectdepartmentNum }}{{ $t('部门')
          }}<img
            src="@/assets/images/pullup.png"
            alt=""
            @click="showSelected = true"
          />
        </div>
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="agree-btn"
          @click="onConfirm"
          >{{ $t('确定') }}</van-button
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { isMobileType } from '@/utils/isMobileType.js'
import {
  Checkbox,
  CheckboxGroup,
  Button,
  Cell,
  CellGroup,
  Field,
  Radio,
  RadioGroup,
  Card,
  Popup,
} from 'vant'
import { getstaffByDepartment } from '@/services/api'
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Popup)
export default {
  name: 'Address',
  props: ['userList', 'selectedList'],
  components: {},
  data() {
    return {
      indexResult: [],
      result: [],
      staffResult: [],
      user: {},
      showAddressList: true,
      currentStaffList: [],
      searchName: null,
      searchList: [],
      searchResult: [],
      selAll: [],
      currentdepartmentList: [],
      staffIdList: [],
      departmentList: [],
      displayList: {},
      totalInfo: [],
      currentInfo: [],
      showSelected: false,
      showSearch: false,
      navList: [],
      addressHeight: null,
      ifFinished: false,
      userStaff: {},
    }
  },
  methods: {
    toggleAll() {
      if (this.selAll.length) {
        if (this.currentInfo == this.totalInfo) {
          this.staffIdList = this.userList
          this.currentInfo.forEach((item) => {
            item.selectNum = item.totalStaffCount
          })
        }
        if (this.currentInfo.children && this.currentInfo.children.length > 0) {
          this.currentInfo.children.forEach((data) => {
            data.staffs &&
              data.staffs.length > 0 &&
              this.userList.forEach((item) => {
                data.staffs.forEach((item1) => {
                  item.id == item1.staffId &&
                    !this.ifSelected(item.id) &&
                    this.staffIdList.push(item)
                })
                this.checkDepartmentChild(data, item)
              })
          })
        }

        if (this.currentInfo.staffs && this.currentInfo.staffs.length > 0) {
          let currentInfoIdList = []
          this.currentInfo.staffs.forEach((item) => {
            currentInfoIdList.push(item.staffId)
          })
          let selectedIdList = this.staffIdList.map((item) => item.id)
          currentInfoIdList.forEach((id) => {
            if (selectedIdList.includes(id)) {
              return
            } else {
              this.userList.forEach((item) => {
                item.id == id && this.staffIdList.push(item)
              })
            }
          })
        }
        this.currentInfo.children &&
          this.currentInfo.children.forEach((item) => {
            item.selectNum = item.totalStaffCount
          })
        this.$refs.departments && this.$refs.departments.toggleAll(true)
        this.$refs.childDepartments &&
          this.$refs.childDepartments.toggleAll(true)
        this.$refs.staffs && this.$refs.staffs.toggleAll(true)
      } else {
        if (this.currentInfo == this.totalInfo) {
          this.staffIdList = []
          this.currentInfo.forEach((item) => {
            item.selectNum = 0
          })
        }
        if (this.currentInfo.children && this.currentInfo.children.length > 0) {
          this.currentInfo.children.forEach((data) => {
            let arr = []
            data.staffs &&
              data.staffs.length > 0 &&
              data.staffs.forEach((item) => arr.push(item.staffId))
            arr = this.delDepartmentChild(data, arr)
            this.staffIdList = this.staffIdList.filter(
              (item) => !arr.includes(item.id)
            )
          })
        }

        if (this.currentInfo.staffs && this.currentInfo.staffs.length > 0) {
          let arr = []
          this.currentInfo.staffs.forEach((item) => {
            arr.push(item.staffId)
          })
          this.staffIdList = this.staffIdList.filter((item) => {
            return !arr.includes(item.id)
          })
        }

        this.currentInfo.children &&
          this.currentInfo.children.forEach((item) => {
            item.selectNum = 0
          })
        this.$refs.departments && this.$refs.departments.toggleAll(false)
        this.$refs.childDepartments &&
          this.$refs.childDepartments.toggleAll(false)
        this.$refs.staffs && this.$refs.staffs.toggleAll(false)
        // this.staffIdList = []
      }
    },
    checkDepartmentChild(data, item) {
      if (data.children.length > 0) {
        data.children.forEach((childItem) => {
          childItem.staffs &&
            childItem.staffs.length > 0 &&
            childItem.staffs.forEach((childStaffs) => {
              item.id == childStaffs.staffId &&
                !this.ifSelected(item.id) &&
                this.staffIdList.push(item)
            })
          this.checkDepartmentChild(childItem, item)
        })
      } else return
    },
    delDepartmentChild(data, arr) {
      if (data.children.length > 0) {
        data.children.forEach((childItem) => {
          childItem.staffs &&
            childItem.staffs.length > 0 &&
            childItem.staffs.forEach((item) => arr.push(item.staffId))
          arr = this.delDepartmentChild(childItem, arr)
        })
        return arr
      } else return arr
    },
    ifSelected(id) {
      return this.staffIdList.some((item) => item.id == id)
    },
    changeIndexDepartmentId(data) {
      let exceedList = []
      let ifexceed = false
      if (this.indexResult.includes(data.departmentId)) {
        data.selectNum = data.totalStaffCount
        let initLength = this.staffIdList.length
        this.userList.forEach((item) => {
          data.staffs &&
            data.staffs.length > 0 &&
            data.staffs.forEach((item1) => {
              item.id == item1.staffId &&
                !this.ifSelected(item.id) &&
                this.staffIdList.push(item)
            })
          this.checkDepartmentChild(data, item)
        })
        let addList = [...this.staffIdList]
        addList = addList.splice(initLength, this.staffIdList.length)
        addList.forEach((item) => {
          if (item.departmentId.includes(',')) {
            exceedList.push(item.id)
            ifexceed = true
          }
        })
        if (ifexceed) {
          this.addIndexDepartmentId(exceedList, data.departmentId)
        }
        this.currentInfo.length === this.indexResult.length &&
          this.$refs.selectedAll.toggleAll(true)
      } else {
        let arr = []
        data.selectNum = 0
        data.staffs &&
          data.staffs.length > 0 &&
          data.staffs.forEach((item) => arr.push(item.staffId))
        arr = this.delDepartmentChild(data, arr)
        arr = Array.from(new Set(arr))
        this.userList.forEach((item) => {
          if (arr.includes(item.id) && item.departmentId.includes(',')) {
            exceedList.push(item.id)
            ifexceed = true
          }
        })
        if (ifexceed) {
          this.delIndexDepartmentId(exceedList, data.departmentId)
        }
        this.staffIdList = this.staffIdList.filter(
          (item) => !arr.includes(item.id)
        )
        this.currentInfo.length !== this.indexResult.length &&
          this.$refs.selectedAll.toggleAll(false)
      }
    },
    addIndexDepartmentId(exceedList, ignoreId) {
      this.currentInfo.forEach((item) => {
        if (item.departmentId != ignoreId) {
          let selectNum = this.handlerIndexDepartmentId(
            item,
            item.selectNum,
            exceedList,
            true
          )
          item.selectNum = selectNum
        }
      })
    },
    handlerIndexDepartmentId(data, selectNum, exceedList, ifAdd) {
      let fn = (data) => {
        if (data.staffs && data.staffs.length > 0) {
          data.staffs.forEach((staff) => {
            if (exceedList.includes(staff.staffId)) {
              ifAdd ? (selectNum = selectNum + 1) : (selectNum = selectNum - 1)
            }
          })
        }
        if (data.children.length > 0) {
          data.children.forEach((childItem) => {
            fn(childItem)
          })
        }
      }
      fn(data, selectNum)
      return selectNum
    },
    delIndexDepartmentId(exceedList, ignoreId) {
      this.currentInfo.forEach((item) => {
        if (item.departmentId != ignoreId) {
          let selectNum = this.handlerIndexDepartmentId(
            item,
            item.selectNum,
            exceedList,
            false
          )
          item.selectNum = selectNum
        }
      })
    },
    changeDepartmentId(data) {
      let exceedList = []
      let ifexceed = false
      if (this.result.includes(data.departmentId)) {
        data.selectNum = data.totalStaffCount
        let initLength = this.staffIdList.length
        this.userList.forEach((item) => {
          data.staffs &&
            data.staffs.length > 0 &&
            data.staffs.forEach((item1) => {
              if (item.id == item1.staffId && !this.ifSelected(item.id)) {
                this.staffIdList.push(item)
              }
            })
          this.checkDepartmentChild(data, item)
        })
        let addList = [...this.staffIdList]
        addList = addList.splice(initLength, this.staffIdList.length)
        addList.forEach((item) => {
          if (item.departmentId.includes(',')) {
            exceedList.push(item)
            ifexceed = true
          }
        })
        if (ifexceed) {
          if (this.currentInfo.children.length > 1) {
            this.currentInfo.children.forEach((curDepartment) => {
              if (curDepartment.departmentId != data.departmentId) {
                exceedList.forEach((user) => {
                  this.checkDepartmentExceed(
                    curDepartment,
                    curDepartment,
                    user.id
                  )
                })
              }
            })
          }
          if (this.currentInfo.staffs && this.currentInfo.staffs.length > 0) {
            this.currentInfo.staffs.forEach((current) => {
              if (current.exceed) {
                if (!this.staffResult.includes(current.staffId)) {
                  exceedList.forEach((staff) => {
                    if (staff.id == current.staffId) {
                      this.staffResult.push(staff.id)
                    }
                  })
                }
              }
            })
          }
        }
      } else {
        let arr = []
        data.selectNum = 0
        data.staffs &&
          data.staffs.length > 0 &&
          data.staffs.forEach((item) => {
            arr.push(item.staffId)
            if (item.exceed) {
              exceedList.push(item)
              ifexceed = true
            }
          })
        arr = this.delDepartmentChild(data, arr)
        let filterList = []
        this.staffIdList.forEach((item) => {
          if (arr.includes(item.id)) {
            if (item.departmentId.includes(',')) {
              if (
                this.currentInfo.staffs &&
                this.currentInfo.staffs.length > 0
              ) {
                this.staffResult = this.staffResult.filter(
                  (staffId) => staffId != item.id
                )
              }
            }
          } else filterList.push(item)
        })
        if (ifexceed) {
          if (this.currentInfo.children.length > 0) {
            this.currentInfo.children.forEach((curDepartment) => {
              if (curDepartment.departmentId != data.departmentId) {
                exceedList.forEach((user) => {
                  this.deleteDepartmentExceed(
                    curDepartment,
                    curDepartment,
                    user.staffId
                  )
                })
              }
            })
          }
        }
        this.staffIdList = filterList
      }
      this.checkIfAllSelected()
    },
    checkDepartmentExceed(data, currentData, id, ifFirst = true) {
      if (ifFirst && data.staffs && data.staffs.length > 0) {
        data.staffs.forEach((staffItem) => {
          if (staffItem.staffId == id) {
            data.selectNum = data.selectNum + 1
            if (data.selectNum == data.totalStaffCount) {
              !this.result.includes(data.departmentId) &&
                this.result.push(data.departmentId)
            }
          }
        })
      }
      currentData.children.length > 0 &&
        currentData.children.forEach((item) => {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) => {
              if (staffItem.staffId == id) {
                data.selectNum = data.selectNum + 1
                if (data.selectNum == data.totalStaffCount) {
                  !this.result.includes(data.departmentId) &&
                    this.result.push(data.departmentId)
                }
              }
            })
          }
          if (item.children.length > 0) {
            this.checkDepartmentExceed(data, item, id, false)
          } else return
        })
    },
    deleteDepartmentExceed(data, currentData, id, ifFirst = true) {
      if (ifFirst && data.staffs && data.staffs.length > 0) {
        data.staffs.forEach((staffItem) => {
          if (staffItem.staffId == id) {
            data.selectNum = data.selectNum - 1
            this.result.length > 0 &&
              this.result.forEach((selectedId, idx) => {
                selectedId == data.departmentId && this.result.splice(idx, 1)
              })
          }
        })
      }
      currentData.children.length > 0 &&
        currentData.children.forEach((item) => {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) => {
              if (staffItem.staffId == id) {
                data.selectNum = data.selectNum - 1
                this.result.length > 0 &&
                  this.result.forEach((selectedId, idx) => {
                    selectedId == data.departmentId &&
                      this.result.splice(idx, 1)
                  })
              }
            })
          }
          if (item.children.length > 0) {
            this.deleteDepartmentExceed(data, item, id, false)
          } else return
        })
    },
    checkIfAllSelected() {
      let currentNum =
        this.currentInfo.staffs && this.currentInfo.children
          ? this.currentInfo.children.length + this.currentInfo.staffs.length
          : this.currentInfo.children.length
      currentNum == this.result.length + this.staffResult.length
        ? this.$refs.selectedAll.toggleAll(true)
        : this.$refs.selectedAll.toggleAll(false)
    },
    changeStaff(id, exceed) {
      if (this.staffResult.includes(id)) {
        this.userList.forEach((item) => {
          item.id == id && this.staffIdList.push(item)
        })
        if (exceed) {
          if (this.currentInfo.children.length > 0) {
            this.addExceed(
              this.currentInfo.children,
              this.currentInfo.children,
              id
            )
            this.currentInfo.children.forEach((childItem) => {
              childItem.totalStaffCount == childItem.selectNum &&
                !this.result.includes(childItem.departmentId) &&
                this.result.push(childItem.departmentId)
            })
          }
        }
      } else {
        this.staffIdList.forEach((item, idx) => {
          item.id == id && this.staffIdList.splice(idx, 1)
        })
        //判断是否多部门
        if (exceed) {
          if (this.currentInfo.children.length > 0) {
            this.deleteExceed(
              this.currentInfo.children,
              this.currentInfo.children,
              id
            )
          }
        }
      }
      this.checkIfAllSelected()
    },
    addExceed(data, currentData, id, childNum, checkingId, checkNum) {
      currentData.forEach((item, index) => {
        if (item.staffs && item.staffs.length > 0) {
          item.staffs.forEach((staffItem) => {
            if (staffItem.staffId == id) {
              if (childNum != undefined && childNum != null) {
                data[childNum].selectNum = data[childNum].selectNum + 1
              } else {
                data[index].selectNum = data[index].selectNum + 1
              }
              if (checkNum) {
                !this.result.includes(checkingId) &&
                  this.result.push(checkingId)
              }
            }
          })
        }
        if (item.children.length > 0) {
          let nowDepartmentId = null
          if (!checkingId) {
            item.pid == this.currentInfo.departmentId &&
              (nowDepartmentId = item.departmentId)
          } else {
            nowDepartmentId = checkingId
          }
          let totalNum = true
          if (!checkNum) {
            item.totalStaffCount != 1 && (totalNum = false)
          }
          childNum ?? (childNum = index)
          this.addExceed(
            data,
            item.children,
            id,
            childNum,
            nowDepartmentId,
            totalNum
          )
        } else return
      })
    },
    deleteExceed(data, currentData, id, childNum, pid) {
      currentData.forEach((item, index) => {
        if (item.staffs && item.staffs.length > 0) {
          item.staffs.forEach((staffItem) => {
            if (staffItem.staffId == id) {
              if (childNum) {
                data[childNum].selectNum = data[childNum].selectNum - 1
              } else {
                data[index].selectNum = data[index].selectNum - 1
              }
              this.result.length > 0 &&
                this.result.forEach((selectedId, idx) => {
                  selectedId == item.departmentId && this.result.splice(idx, 1)
                  selectedId == item.pid && this.result.splice(idx, 1)
                  pid && selectedId == pid && this.result.splice(idx, 1)
                })
            }
          })
        }
        if (item.children.length > 0) {
          childNum ?? (childNum = index)
          this.deleteExceed(data, item.children, id, childNum, item.pid)
        } else return
      })
    },
    changeStaffBySearch(id) {
      if (this.searchResult.includes(id)) {
        this.userList.forEach((item) => {
          item.id == id && this.staffIdList.push(item)
        })
      } else {
        this.staffIdList.forEach((item, idx) => {
          item.id == id && this.staffIdList.splice(idx, 1)
        })
      }
    },
    leaveSearch() {
      if (this.currentInfo == this.totalInfo) {
        this.currentInfo.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item, true)
        })
        this.currentInfo.length == this.indexResult.length
          ? this.$refs.selectedAll.toggleAll(true)
          : this.$refs.selectedAll.toggleAll(false)
      } else {
        if (this.currentInfo.children.length > 0) {
          this.currentInfo.children.forEach((item) => {
            item.selectNum = this.checkIfChildDepartmentSelected(item)
          })
        }
        if (this.currentInfo.staffs && this.currentInfo.staffs.length > 0) {
          let selectedIdList = this.staffIdList.map((item) => item.id)
          this.staffResult = []
          this.currentInfo.staffs.forEach((item) => {
            selectedIdList.includes(item.staffId) &&
              this.staffResult.push(item.staffId)
          })
        }
        this.checkIfAllSelected()
      }
      this.searchName = ''
      this.showSearch = false
    },
    async getDepartment(companyId) {
      const res = await getstaffByDepartment({ companyId })
      this.totalInfo = res
      this.currentInfo = res
      this.init()
      this.ifFinished = true
    },
    checkIfChildDepartmentSelected(data, ifIndex) {
      let checkNum = (departmentData) => {
        if (
          departmentData.children.length > 0 ||
          (departmentData.staffs && departmentData.staffs.length > 0)
        ) {
          let departmentNum = 0
          departmentData.children.length > 0 &&
            departmentData.children.forEach((item) => {
              if (
                item.children.length == 0 &&
                (!item.staffs || item.staffs.length == 0)
              )
                return 0
              let totalNum = checkNum(item)
              departmentNum += totalNum
            })
          let staffsNum = 0
          departmentData.staffs &&
            departmentData.staffs.length > 0 &&
            departmentData.staffs.forEach((item) => {
              this.staffIdList.forEach((item1) => {
                item1.id == item.staffId && staffsNum++
              })
            })
          return departmentNum + staffsNum
        } else return 0
      }
      let selectNum = checkNum(data)
      data.totalStaffCount != 0 &&
        data.totalStaffCount == selectNum &&
        (ifIndex
          ? !this.indexResult.includes(data.departmentId) &&
            this.indexResult.push(data.departmentId)
          : !this.result.includes(data.departmentId) &&
            this.result.push(data.departmentId))
      if (data.totalStaffCount !== selectNum) {
        if (ifIndex) {
          this.indexResult.includes(data.departmentId) &&
            (this.indexResult = this.indexResult.filter(
              (item) => item != data.departmentId
            ))
        } else {
          if (this.result.includes(data.departmentId)) {
            this.result = this.result.filter(
              (item) => item != data.departmentId
            )
          }
        }
      }
      return selectNum
    },
    toChild(data) {
      this.result = []
      this.staffResult = []
      this.navList.push(data)
      this.showAddressList = false
      this.currentInfo = data
      if (data.staffs && data.staffs.length > 0) {
        data.staffs = [...data.staffs].sort(
          (a, b) => (b.leader ? 1 : 0) - (a.leader ? 1 : 0)
        )
      }
      if (
        data.staffs &&
        data.staffs.length > 0 &&
        this.staffIdList.length > 0
      ) {
        this.staffIdList.forEach((item) => {
          data.staffs.forEach((item1) => {
            item.id == item1.staffId && this.staffResult.push(item1.staffId)
          })
        })
      }
      data.children.length > 0 &&
        data.children.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item)
        })
      this.checkIfAllSelected()
    },
    onConfirm() {
      if (!this.ifFinished) return
      this.$emit('confirm', this.staffIdList, this.displayList, this.totalInfo)
    },
    goBack() {
      this.$emit('back')
    },
    init() {
      if (this.selectedList.length < 1) return
      this.staffIdList = [...this.selectedList]
      this.currentInfo.forEach((item) => {
        item.selectNum = this.checkIfChildDepartmentSelected(item, true)
      })
      this.currentInfo.length == this.indexResult.length
        ? this.$refs.selectedAll.toggleAll(true)
        : this.$refs.selectedAll.toggleAll(false)
    },
    toIndex() {
      this.indexResult = []
      this.navList = []
      this.showAddressList = true
      this.currentInfo = this.totalInfo
      this.currentInfo.forEach((item) => {
        item.selectNum = this.checkIfChildDepartmentSelected(item, true)
      })
      this.currentInfo.length === this.indexResult.length
        ? this.$refs.selectedAll.toggleAll(true)
        : this.$refs.selectedAll.toggleAll(false)
    },
    toMenu(data, idx) {
      this.result = []
      this.staffResult = []
      this.currentInfo = data
      this.navList = this.navList.slice(0, idx + 1)
      if (
        data.staffs &&
        data.staffs.length > 0 &&
        this.staffIdList.length > 0
      ) {
        this.staffIdList.forEach((item) => {
          data.staffs.forEach((item1) => {
            item.id == item1.staffId && this.staffResult.push(item1.staffId)
          })
        })
      }
      data.children.length > 0 &&
        data.children.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item)
        })
      this.checkIfAllSelected()
    },
    selectStaff(v) {
      this.searchList = []
      let arr = this.userList.filter((item) => {
        if (!item.name) return
        return item.name.includes(v)
      })
      this.searchList = arr
    },
    toSearch() {
      if (!this.ifFinished) return
      this.searchList = []
      this.searchResult = []
      if (this.staffIdList.length > 0) {
        this.staffIdList.forEach((item) => {
          this.searchResult.push(item.id)
        })
      }
      this.showSearch = true
    },
    toDisplay() {
      this.showSelected = true
    },
    checkselectedDepartment(data, arr) {
      if (data.length > 0) {
        data.forEach((item) => {
          arr.push(item.departmentId)
          this.checkselectedDepartment(item.children, arr)
        })
      } else return
    },
    checkTotalStaffCount(data, id) {
      let selectedData = {}
      data.some((item) => {
        if (item.departmentId == id) {
          selectedData = item
          return true
        } else {
          if (item.children && item.children.length > 0) {
            let returnData = this.checkTotalStaffCount(item.children, id)
            returnData.staffs && (selectedData = returnData)
          } else return
        }
      })
      return selectedData
    },
    fliterDepartment(data, arr) {
      data.forEach((item) => {
        item.staffs &&
          item.staffs.length > 0 &&
          item.staffs.forEach((staffItem) => arr.push(staffItem.staffId))
        item.children.length > 0 && this.fliterDepartment(item.children, arr)
      })
      return arr
    },
    //上级部门查询
    checkSuperiorDepartment(data, departmentId, arr) {
      let response = null
      if (data.pid) {
        let pidDepartmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          data.pid
        )
        let slectedNum = this.staffIdList.filter(
          (item) => item.departmentId == pidDepartmentInfo.departmentId
        ).length
        if (
          slectedNum + data.totalStaffCount ==
          pidDepartmentInfo.totalStaffCount
        ) {
          let childData = pidDepartmentInfo.children.filter(
            (item) => item.departmentId == departmentId
          )[0]
          response = this.checkSuperiorDepartment(
            pidDepartmentInfo,
            pidDepartmentInfo.departmentId,
            arr,
            childData
          )
        } else {
          response = data
          return response
        }
      } else {
        response = data
        return response
      }
      return response
    },
    //下级部门查询
    checkSubordinateDepartment(data, selectedIdList) {
      let bl = true
      if (data.staffs && data.staffs.length > 0) {
        bl = data.staffs.every((childStaff) =>
          selectedIdList.includes(childStaff.staffId)
        )
      }
      if (bl && data.children.length > 0) {
        data.children.forEach((item) => {
          bl = this.checkSubordinateDepartment(item, selectedIdList)
        })
      }
      return bl
    },
    delStaffIdList(id) {
      let filterArr = []
      this.staffIdList.forEach((item) => {
        if (item.id == id) {
          if (item.departmentId.includes(',')) {
            if (this.currentInfo.length) {
              this.delIndexDepartmentId([id], null)
            } else {
              if (this.currentInfo.children.length > 0) {
                this.deleteExceed(
                  this.currentInfo.children,
                  this.currentInfo.children,
                  id
                )
              }
            }
          } else {
            this.currentInfo.forEach((info) => {
              info.departmentId == item.departmentId &&
                (info.selectNum = info.selectNum - 1)
            })
          }
        } else {
          filterArr.push(item)
        }
      })
      this.staffIdList = filterArr
      this.staffResult.length > 0 &&
        (this.staffResult = this.staffResult.filter((item) => item != id))
      if (this.currentInfo.length) {
        this.currentInfo.forEach((item) => {
          if (item.selectNum != item.totalStaffCount) {
            this.indexResult = this.indexResult.filter(
              (departmentId) => departmentId != item.departmentId
            )
          }
        })
      }
      // this.staffIdList = this.staffIdList.filter(item => item.id != id)
      // this.staffResult = this.staffResult.filter(item => item != id)
    },
    delstaff(id, idx) {
      this.delStaffIdList(id)
      this.displayList.staff.splice(idx, 1)
      this.checkIfAllSelected()
    },
    delDepartment(id) {
      this.AllDelete(this.totalInfo, id)
      this.displayList.department = this.displayList.department.filter(
        (item) => item.departmentId != id
      )

      if (this.currentInfo == this.totalInfo) {
        this.indexResult = this.indexResult.filter((item) => item != id)
        this.$refs.selectedAll && this.$refs.selectedAll.toggleAll(false)
        this.currentInfo.forEach((item) => {
          item.departmentId == id && (item.selectNum = 0)
        })
      } else {
        this.currentInfo.children.forEach((item) => {
          item.departmentId == id && (item.selectNum = 0)
        })
        // this.result = this.indexResult.filter(item => item != id)
        this.checkIfAllSelected()
      }
    },
    AllDelete(data, id) {
      data.forEach((item) => {
        // if (this.currentInfo.departmentId == item.departmentId) {
        //   this.currentInfo.children.forEach(currentItem => {
        //     currentItem.selectNum = 0
        //   })
        // }
        if (id) {
          if (item.departmentId == id) {
            if (item.staffs && item.staffs.length > 0) {
              item.staffs.forEach((staffItem) =>
                this.delStaffIdList(staffItem.staffId)
              )
            }
            if (item.children.length > 0) {
              this.AllDelete(item.children)
            } else return
          } else {
            if (item.children.length > 0) {
              this.AllDelete(item.children, id)
            } else return
          }
        } else {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) =>
              this.delStaffIdList(staffItem.staffId)
            )
          }
          if (item.children.length > 0) {
            this.AllDelete(item.children)
          } else return
        }
      })
    },
    isWeixin() {
      if (
        window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        'micromessenger'
      ) {
        if (isMobileType.iOS()) {
          this.addressHeight =
            parseInt((370 / 812) * document.body.scrollHeight) + 'px'
        } else {
          this.addressHeight =
            parseInt((400 / 812) * document.body.scrollHeight) + 'px'
        }
      } else {
        this.addressHeight =
          parseInt((400 / 812) * document.body.scrollHeight) + 'px'
      }
    },
    handlerFinalDepartment(data, idList) {
      if (data.children.length > 0) {
        data.children.forEach((item) => {
          idList.push(item.departmentId)
          if (item.children.length > 0) {
            this.handlerFinalDepartment(item, idList)
          }
        })
      }
    },
  },
  computed: {
    selectNum() {
      return this.staffIdList.length || 0
    },
    selectdepartmentNum() {
      if (this.staffIdList.length == 0) {
        return 0
      } else {
        let warpList = []
        // let arr = Array.from(new Set(this.staffIdList.map(item => item.departmentId)))
        let arr = []
        this.staffIdList.forEach((item) => {
          if (item.departmentId.includes(',')) {
            let departmentIdList = item.departmentId.split(',')
            departmentIdList.forEach((id) => arr.push(id * 1))
          } else arr.push(item.departmentId * 1)
        })
        arr = Array.from(new Set(arr))
        this.totalInfo.forEach((item) => {
          let departmentList = []
          departmentList.push(item.departmentId)
          this.checkselectedDepartment(item.children, departmentList)
          arr.forEach((id) => {
            if (departmentList.includes(id)) warpList.push(item.departmentId)
          })
        })
        let num = Array.from(new Set(warpList)).length
        return num
      }
    },
  },
  watch: {
    selectdepartmentNum: {
      deep: true,
      handler: function () {
        if (
          this.staffIdList.length == 0 &&
          !this.displayList.department.length
        ) {
          return
        } else {
          let warpList = []
          let arr = []
          this.staffIdList.forEach((item) => {
            if (item.departmentId.includes(',')) {
              let departmentIdList = item.departmentId.split(',')
              departmentIdList.forEach((id) => arr.push(id))
            } else arr.push(item.departmentId)
          })
          arr = Array.from(new Set(arr))
          this.totalInfo.forEach((item) => {
            let departmentList = []
            departmentList.push(item.departmentId)
            this.checkselectedDepartment(item.children, departmentList)
            arr.forEach((id) => {
              if (departmentList.includes(id)) warpList.push(item.departmentId)
            })
          })
          let selectedIdList = this.staffIdList.map((item) => item.id)
          let department = []
          let includeDepartment = []
          arr.forEach((departmentId) => {
            let slectedNum = this.staffIdList.filter((item) => {
              if (item.departmentId.includes(',')) {
                let departmentIdList = item.departmentId.split(',')
                return departmentIdList.includes(departmentId)
              } else return item.departmentId == departmentId
            }).length
            let departmentInfo = this.checkTotalStaffCount(
              this.totalInfo,
              departmentId
            )
            if (
              departmentInfo.staffs &&
              slectedNum == departmentInfo.staffs.length
            ) {
              //判断是否最底层部门
              if (departmentInfo.children.length == 0) {
                let finalDepartment = this.checkSuperiorDepartment(
                  departmentInfo,
                  departmentId,
                  arr
                )
                finalDepartment &&
                  department.every(
                    (item) => item.departmentId != finalDepartment.departmentId
                  ) &&
                  department.push(finalDepartment)
              } else {
                let ifAllChildSelected = []
                departmentInfo.children.forEach((childItem) => {
                  let bl = this.checkSubordinateDepartment(
                    childItem,
                    selectedIdList
                  )
                  ifAllChildSelected.push(bl)
                })
                if (ifAllChildSelected.every((item) => item == true)) {
                  let finalDepartment = this.checkSuperiorDepartment(
                    departmentInfo,
                    departmentId,
                    arr
                  )
                  if (
                    finalDepartment &&
                    department.every(
                      (item) =>
                        item.departmentId != finalDepartment.departmentId
                    )
                  ) {
                    department.push(finalDepartment)
                    this.handlerFinalDepartment(
                      finalDepartment,
                      includeDepartment
                    )
                  }
                } else return
              }
            }
          })
          includeDepartment = Array.from(new Set(includeDepartment))
          department = department.filter((item) => {
            if (item.pid) {
              return (
                !includeDepartment.includes(item.pid) &&
                !includeDepartment.includes(item.departmentId)
              )
            } else return true
          })
          // this.displayList.department = [...department]
          // let staffInDepartment = []
          // staffInDepartment = this.fliterDepartment(department, staffInDepartment)
          // this.displayList.staff = this.staffIdList.filter(
          //   item => !staffInDepartment.includes(item.id)
          // )
          this.displayList.department = []
          if (!this.staffIdList.find((item) => item.id == this.user.id)) {
            this.staffIdList.push(this.userStaff)
          }
          this.displayList.staff = this.staffIdList
        }
      },
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
  },
  mounted() {
    this.isWeixin()
    this.getDepartment(this.user.companyId)
    this.userStaff = this.userList.filter(
      (staffId) => staffId.id == this.user.id
    )[0]
  },
}
</script>
<style lang="less" scoped>
.addressList {
  height: 100%;
  background-color: #f6f6f6;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  .addressList-nav {
    background-color: #ffffff;
    padding: 14px 18px;
    .searchBox {
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      width: 340px;
      margin-bottom: 16px;
      // height: 30px;
      .search-name {
        padding: 3px 15px;
      }
    }
    .menu-box {
      display: flex;
      color: #009bff;
      font-size: 14px;
      line-height: 24px;
      white-space: nowrap;
      overflow: auto;
      .child-menu {
        display: flex;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          padding-left: 8px;
          img {
            width: 16px;
            height: 17px;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .addressList-all {
    height: 56px;
    background-color: #ffffff;
    padding-left: 16px;
    display: flex;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 10px;
  }
  .addressList-card {
    flex: 1;
    overflow: auto;
    margin-bottom: 10px;
  }
  .staffs-card {
    display: flex;
    margin-left: 9px;
    img {
      width: 46px;
      height: 47px;
      margin-right: 10px;
    }
    .staffs-card-title {
      display: flex;
      align-items: center;
    }
    .staffs-card-tag {
      padding-left: 4px;
      padding-right: 4px;
      height: 18px;
      border-radius: 4px;
      border: 1px solid #03d39d;
      font-size: 12px;
      color: #03d39d;
      line-height: 16px;
      text-align: center;
      margin-left: 12px;
    }
    .staffs-card-name {
      line-height: 24px;
    }
    .staffs-card-job {
      line-height: 24px;
      color: #999999;
    }
  }
  .agreeBox {
    width: 100%;
    background-color: #ffffff;
    bottom: 2px;
    left: 0;
    .select-info {
      padding-left: 16px;
      font-size: 14px;
      color: #009bff;
      margin-top: 17px;
      margin-bottom: 12px;
      line-height: 24px;
      img {
        margin-left: 16px;
        width: 18px;
        height: 12px;
      }
    }
    .agree-btn {
      border: none;
      width: 351px;
      margin: 0px auto 23px;
    }
  }
}
.navBar-wrap {
  width: 100%;
  background: #ffffff;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #ececec;
  font-size: 18px;
  position: relative;
  .arrow {
    height: 100%;
    padding: 3px 19px;
    position: absolute;
  }
  .title {
    font-size: 17px;
    font-weight: 500;
  }
  .selected-navBar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .left-icon {
      height: 100%;
      padding: 3px 19px;
      position: absolute;
      left: 0px;
    }
  }
}
.contact-card {
  display: flex;
  img {
    width: 19px;
    height: 21px;
    margin: 0px 7px;
  }
  > div {
    width: 1px;
    height: 20px;
    background: #ededed;
  }
}
.search-model {
  height: 100%;
  width: 100%;
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
  .search-navBar {
    width: 100%;
    background: #ffffff;
    line-height: 40px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 18px;
    .left-icon {
      height: 100%;
      padding-top: 3px;
    }
    .searchBox {
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      width: 312px;
      // height: 30px;
      .search-name {
        padding: 3px 15px;
      }
    }
  }
  .search-list {
    flex: 1;
    overflow: auto;
    padding-bottom: 122px;
  }
}
.display-wrap {
  background: #fefffe;
  padding: 0 16px;
  li {
    color: #333333;
    line-height: 24px;
    display: flex;
    height: 45px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    justify-content: space-between;
    img {
      width: 16px;
      height: 17px;
    }
  }
}
</style>
